export const VehicleOptionType = {
  Comfort: 1,
  Convenience: 2,
  Exterior: 3,
  MediaCommunication: 4,
  Power: 5,
  SafetyAndSecurity: 6,
}
